function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M12 11.222L14.667 13 13.777 9.889 16 8 13.333 7.667 12 5 10.667 7.667 8 8 10.223 9.889 9.333 13z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19,21.723V10V9V4c0-1.104-0.896-2-2-2H7C5.896,2,5,2.896,5,4v5v1v11.723l7-4.571L19,21.723z M8,8l2.667-0.333L12,5 l1.333,2.667L16,8l-2.223,1.889L14.667,13L12,11.222L9.333,13l0.89-3.111L8,8z"
});

function SvgBest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 507,
    height: 507,
    viewBox: "0 0 507.289 507.289",
    style: {
      enableBackground: "new 0 0 507.289 507.289"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest);
export default __webpack_public_path__ + "static/media/best.c43261a0.svg";
export { ForwardRef as ReactComponent };